/**
 * ServicesSection - Services showcase with modal
 * Features: Grid layout, modal interaction, lazy loading
 */
import { useState } from "react";
import { Container, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ServiceCard from "../../../shared/Optimized/ServiceCard";
import ServiceModal from "../../../shared/Optimized/ServiceModal";
import { getServices } from "../constants/services";
import { zoomIn } from "../constants/animations";

const ServicesSection = () => {
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState(null);
  const services = getServices(t);

  const handleModalOpen = (modalKey) => {
    setOpenModal(modalKey);
  };

  const handleModalClose = () => {
    setOpenModal(null);
  };

  const currentService = services.find((s) => s.key === openModal);

  return (
    <Container sx={{ py: 6 }}>
      <Typography
        variant="overline"
        align="center"
        display="block"
        sx={{ color: "primary.main", fontWeight: 700, letterSpacing: "0.15em", mb: 1 }}
      >
        {t("home.services.eyebrow")}
      </Typography>
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{
          fontWeight: 700,
          fontSize: { xs: "1.8rem", md: "2.2rem" },
          mb: 4,
          color: "text.primary",
        }}
      >
        {t("home.services.title")}
      </Typography>
      <Grid container spacing={4}>
        {services.map((service) => (
          <Grid item xs={12} sm={6} md={4} key={service.key}>
            <ServiceCard
              service={service}
              onClick={handleModalOpen}
              variants={zoomIn}
            />
          </Grid>
        ))}
      </Grid>

      {/* Modal optimizado */}
      <ServiceModal
        service={currentService}
        isOpen={!!openModal}
        onClose={handleModalClose}
      />
    </Container>
  );
};

export default ServicesSection;
